import React from 'react';
import AdminChat from './admin-chat';
import { get_user } from '../../utils/functions';
import TrainerChat from './trainer-chat';

const Chat = () => {
  const user = get_user();
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
      }}
    >
      {/* All staff (super-admin 1, admin 2, trainer 4, head-coach 5) use the same
          TrainerChat view so every role sees an identical, current chat UI.
          (Clients never reach the web portal; AdminChat kept only as a fallback.) */}
      {[1, 2, 4, 5].includes(Number(user?.userType)) ? <TrainerChat /> : <AdminChat />}
    </div>
  );
};

export default Chat;
